/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UnlockConnectorTask
 */
export interface UnlockConnectorTask {
    /**
     *
     * @type {number}
     * @memberof UnlockConnectorTask
     */
    connectorIndex?: number;
}

/**
 * Check if a given object implements the UnlockConnectorTask interface.
 */
export function instanceOfUnlockConnectorTask(
    value: object,
): value is UnlockConnectorTask {
    return true;
}

export function UnlockConnectorTaskFromJSON(json: any): UnlockConnectorTask {
    return UnlockConnectorTaskFromJSONTyped(json, false);
}

export function UnlockConnectorTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UnlockConnectorTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
    };
}

export function UnlockConnectorTaskToJSON(
    value?: UnlockConnectorTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
    };
}
